"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryDrugsAndGasesGroup_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryDrugsAndGasesGroup_Factory = /** @class */ (function () {
    function SurgeryDrugsAndGasesGroup_Factory() {
    }
    SurgeryDrugsAndGasesGroup_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            Quantity: model.Quantity,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    SurgeryDrugsAndGasesGroup_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            Quantity: model.Quantity,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return SurgeryDrugsAndGasesGroup_Factory;
}());
exports.SurgeryDrugsAndGasesGroup_Factory = SurgeryDrugsAndGasesGroup_Factory;
